// @ts-nocheck

import { isBetEligible } from '@winamax/missions-lib';

import { selectMPFamilies, selectMPFamiliesOrder } from '../selectors/families';
import { selectMPUserProgress, selectMPUserProgressOpen } from '../selectors/user';
import { MPCardStatuses } from '../types/cards';

const getEligibleCards = (globalState, oddsId) => {
  const { basket, entities } = globalState;
  const items = basket.items;
  const familiesOrder = selectMPFamiliesOrder(globalState);
  const families = selectMPFamilies(globalState);
  const userProgress = selectMPUserProgress(globalState);
  const progressOpen = selectMPUserProgressOpen(globalState);

  const familiesOrderAvailable = familiesOrder.filter((f) => progressOpen.includes(f));

  const item = items[oddsId];

  const eligibilityOptions = {
    basket,
    entities,
    item: item ?? null,
  };

  const cards = [];

  for (let i = 0; i < familiesOrderAvailable.length; i++) {
    const { eligibility } = families?.[familiesOrderAvailable[i]] ?? {};

    if (eligibility) {
      const isEligible = isBetEligible({
        eligibility,
        ...eligibilityOptions,
      });

      if (isEligible) {
        const familyId = familiesOrderAvailable[i];

        Object.keys(userProgress[familyId].cards).forEach((key) => {
          if (userProgress[familyId].cards[key].status === MPCardStatuses.OPEN) {
            cards.push({
              familyId,
              index: parseInt(key, 10),
            });
          }
        });
      }
    }
  }

  return cards;
};

export default getEligibleCards;
